import {z} from 'zod';

/**
 * Tag attached to an Event. System tags are Wayra-curated and have a
 * null organizerId; free-form tags are organizer-scoped and always
 * isPublic.
 */
export const EventTag = z.object({
  id: z.string().uuid(),
  name: z.string().min(1).max(50),
  isSystem: z.boolean(),
  isPublic: z.boolean(),
  organizerId: z.string().uuid().nullable(),
});

export type EventTag = z.infer<typeof EventTag>;
